import { TnEngineContext, TnEngineExtraContext } from "pytha";
import { Sprite } from "three";

class GraphicStore {
    context: TnEngineContext; // 核心库上下文
    extraContext: TnEngineExtraContext; // 扩展库上下文

    // 存放全局广告牌对象
    spriteMap: { [key: string]: { sprite: Sprite, text: string, isMonitor: boolean, isSelect: boolean } } = {}
}

export const graphicStore = new GraphicStore();